/** 
    @function shadeColor 
    shade color of received color
    @params color {string} - given color
    @params percent {number} - percent to shade
    @returns {string}
*/

export function shadeColor(color: string, percent: number) {
  if (!/^#[0-9A-F]{6}$/i.test(color)) {
    throw new Error("Invalid color format. Expected #RRGGBB");
  }

  const R = parseInt(color.substring(1, 3), 16);
  const G = parseInt(color.substring(3, 5), 16);
  const B = parseInt(color.substring(5, 7), 16);

  let newR = Math.round(R * (1 + percent / 100));
  let newG = Math.round(G * (1 + percent / 100));
  let newB = Math.round(B * (1 + percent / 100));

  newR = Math.min(newR, 255);
  newG = Math.min(newG, 255);
  newB = Math.min(newB, 255);

  const RR = newR.toString(16).padStart(2, "0");
  const GG = newG.toString(16).padStart(2, "0");
  const BB = newB.toString(16).padStart(2, "0");

  return "#" + RR + GG + BB;
}
